import { render, staticRenderFns } from "./ExternalAppList.vue?vue&type=template&id=061a5cf7&"
import script from "./ExternalAppList.vue?vue&type=script&lang=js&"
export * from "./ExternalAppList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports